<template>
  <div>
    <el-dialog
            title="用户服务协议"
            :visible.sync="agreement"
            width="50%">
      <public-agreement></public-agreement>
      <span slot="footer" class="dialog-footer">
        <el-button @click="agreement = false">取 消</el-button>
        <el-button type="primary" @click="agreement = false">确 定</el-button>
      </span>
    </el-dialog>
    <div class="box760">
      <div class="steps flex justify-content align-items">
        <div class="item underway justify-content align-items flex column">
          <p class="circular"><i></i></p>
          <p class="text">填写资料</p>
        </div>
        <div class="line"></div>
        <div class="item justify-content align-items flex column">
          <p class="circular"><i></i></p>
          <p class="text">达人培训</p>
        </div>
        <div class="line"></div>
        <div class="item justify-content align-items flex column">
          <p class="circular"><i></i></p>
          <p class="text">认证成功</p>
        </div>
      </div>
    </div>
    <div class="box760 white-bg shadow fromBox border">
      <h3 class="attestation-title">您选择了达人认证，请如实填写以下资料</h3>
      <div class="attestation-content">
        <el-form ref="darenForm" :model="form" :rules="rules" label-width="200px" label-position="top">
          <el-form-item label="您的姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
          </el-form-item>
          <el-form-item label="您的性别" prop="sex">
            <el-radio-group v-model="form.sex">
              <el-radio label="0">女</el-radio>
              <el-radio label="1">男</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="您的出生日期" prop="birthday">
            <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    v-model="form.birthday"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    style="width: 100%;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="您的职业" prop="occupation_id">
            <el-select v-model="form.occupation_id" placeholder="请选择职业" style="width:100%;">
              <el-option
                      v-for="item in occupation_id"
                      :key="item.id"
                      :label="item.occupation_name"
                      :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="您的区域" prop="area">
            <el-select v-model="form.area" placeholder="请选择区域" style="width:100%;">
              <el-option
                      v-for="item in area"
                      :key="item.id"
                      :label="item.area"
                      :value="item.area">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="个人介绍" prop="content">
            <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请简单介绍自己"
                    v-model="form.content">
            </el-input>
          </el-form-item>
          <el-form-item label="您的手机号码" prop="mobile">
            <el-input v-model.number="form.mobile" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item label="验证码" class="relative" prop="mobile_code">
            <el-button size="mini" type="warning" plain class="get-code absolute ff9203" :disabled="disabled" @click="sendCode" v-if="form.mobile">{{btnTxt}}</el-button>
            <el-input v-model="form.mobile_code" placeholder="请输入验证码"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-checkbox v-model="checked">我已阅读并同意<a class="ff9203" @click="agreement = true">《用户服务协议》</a></el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submission('darenForm')" style="width: 100%;">提交资料</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import {
  occupation,
  getArea,
  sentSms,
  userAuth
} from '@/config/api.js'
import axios from 'axios'
import PublicAgreement from '@/components/Agreement'
const checkPhone = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('手机号不能为空'));
  } else {
    const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
    if (reg.test(value)) {
      callback();
    } else {
      return callback(new Error('请输入正确的手机号'));
    }
  }
};
export default {
  name: 'DarenAttestation',
  components: {PublicAgreement},
  data () {
    return {
      form: {
        phone: null,
        mobile_code: null,
        name: '',
        sex: null,
        content: '',
        occupation_id: null,
        birthday: '',
        area: '',
      },
      user_type: null,
      is_auth: null,
      daren_name: '',
      head_img: '',
      openid: '',
      unionid: '',
      auth_type: 0,
      occupation_id: [],
      area: [],
      label: '',
      id: '',
      value: '',
      agreement: false,
      disabled:false,
      time:0,
      btnTxt:"获取验证码",
      checked: false,
      fullscreenLoading: false,
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        birthday: [
          { required: true, message: '请选择时间', trigger: 'change' }
        ],
        occupation_id: [
          { required: true, message: '请选择职业', trigger: 'change' }
        ],
        area: [
          { required: true, message: '请选择区域', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请输入个人介绍', trigger: 'blur' }
        ],
        mobile: [
          {validator: checkPhone, trigger: 'blur'}
        ],
        mobile_code: [
          { required: true, message: '请输入验证码'}
        ]
      },
    }
  },
  methods: {
    getOccupation () {
      axios.get(occupation)
              .then(res => {
                this.occupation_id = res.data.data.list;
              })
    },
    getArea () {
      let data = {
        token:'e44'
      };
      this.$post(getArea,data)
              .then(res => {
                this.area = res.data;
              })
    },
    sendCode(){
      let reg=11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/;
      if(this.form.mobile === ''){
        this.$message.error('请输入手机号码')
      }else if(!reg.test(this.form.mobile)){
        this.$message.error('手机格式不正确');
      } else {
        let data = {
          mobile_phone:Number(this.form.mobile),
          openid:this.$store.state.openid,
        };
        this.time=60;
        this.disabled=true;
        this.timer();
        this.$post(sentSms,data)
                .then(res => {
                  this.$message.success(res.msg)
                })
                .catch(err => {
                  this.$message.error(err.msg)
                })
      }
    },
    timer(){
      if (this.time > 0) {
        this.time--;
        this.disabled=true;
        this.btnTxt=this.time+"秒后重新获取验证码";
        setTimeout(this.timer, 1000);
      }else {
        this.time=0;
        this.btnTxt="重新获取验证码";
        this.disabled=false;
      }
    },
    submission (formName) {
      if (this.checked) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let data = {
              openid: this.$store.state.openid,
              unionid: this.$store.state.unionid,
              user_type: 1,
              name: this.form.name,
              sex: Number(this.form.sex),
              content: this.form.content,
              occupation_id: Number(this.form.occupation_id),
              birthday: this.form.birthday,
              area: this.form.area,
              phone: this.form.mobile,
              mobile_code: this.form.mobile_code,
            };
            this.$post(userAuth,data)
                    .then(res => {
                      const data = res.data;
                      this.auth_token = data.auth_token;
                      this.id = Number(res.data.id);
                      this.is_auth = Number(res.data.is_auth);
                      this.user_type = Number(res.data.user_type);
                      this.$store.commit('changeIsAuth',0);
                      this.$store.commit('changeId',this.id);
                      this.$store.commit('changeUserType',1);
                      this.$store.commit('changeAuthToken',this.auth_token);
                      this.$store.commit('changeAuthType',0);
                      setTimeout(() => {
                        this.$message.success('您已成功提交资料');
                        setTimeout(() => {
                          this.$router.push('/daren-register/select')
                        },1000)
                      }, 1000);
                    })
                    .catch(err => {
                      window.console.log(err);
                      setTimeout(() => {
                        this.$message.error(err.msg);
                      },1000);
                    })
          } else {
            return false;
          }
        })
      }else {
        this.$message.error('你还没有阅读并同意用户服务协议');
      }
    }
  },
  created() {
    this.getOccupation();
    this.getArea();
  }
}
</script>
<style>
  .get-code{z-index:9;right: 6px;top:6px;}
</style>
